module.exports = __webpack_public_path__ + "349b6b629fa68851818876a0498faf68.png";